import React from "react";
import { TrueScan } from "../../components/organisms/truescan/TrueScan";

export const TrueScanTab = () => {
  return (
    <div className="">
      <TrueScan />
    </div>
  );
};
